import React from 'react';
import {
  DisclaimerBannerContainer,
  DisclaimerBannerText,
} from './DisclaimerBanner.styles';

const DisclaimerBanner = ({ source }) => (
  <DisclaimerBannerContainer>
    <DisclaimerBannerText>
      {source === 'google'
        ? 'Always verify whether or not an actual crash has occurred.'
        : 'Verify if this device information applies to the caller and their emergency.'}
    </DisclaimerBannerText>
  </DisclaimerBannerContainer>
);

export default DisclaimerBanner;
